<template>
  <b-modal
    v-model="editorShown"
    centered
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
  >
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="editorShown = false">
        Cancel
      </b-button>
    </template>
    <b-form-group
      label="We found more than one record that matches your search:"
    >
    </b-form-group>
    <div class="eoc-row" v-for="eoc in eocs" :key="eoc.id">
      <div>
        <span
          class="badge px-1 py-1 text-white eoc-field"
          :class="
            eoc.status == 'Pending'
              ? 'badge-warning'
              : eoc.status == 'Active'
              ? 'badge-success'
              : 'badge-danger'
          "
          >{{ eoc.status[0] }}</span
        >
        <span class="eoc-field loc-fixed-size"
          ><div
            v-if="eoc.levelOfCare"
            class="badge px-1 py-1 text-white eoc-field  badge-info"
          >
            {{ eoc.levelOfCare?.name }}
          </div></span
        >
        <span class="eoc-field">{{ eoc.patient.mrn }}-{{ eoc.eocn }}</span>
        <span class="eoc-field">
          {{ eoc.patient.firstName }}
          {{ eoc.patient.middleName }}
        </span>
      </div>
      <div>
        <a
          class="eoc-select"
          :href="`/#/episode-of-care/${eoc.id}`"
          target="_blank"
          >Select</a
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PatientSearchResultModal",
  props: ["value", "eocs"],

  methods: {
    closeModal() {
      this.editorShown = false;
    }
  },
  computed: {
    editorShown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style>
.eoc-row {
  display: flex;
  border: solid 1px gray;
  padding: 0.5rem;
  border-radius: 0.5rem;
  margin: 0.5rem;
  align-items: center;
  justify-content: space-between;
}
.eoc-field {
  padding: 0.2rem;
}

.loc-fixed-size {
  width: 3rem;
  display: inline-block;
}
.eoc-select {
  font-size: bold;
}
</style>
